// What the screens use. Every answer goes through dataLayer(): stored on the
// device first, sent in the background, never waited on by a screen.

import { createDataLayer } from "./layer";
import type { DataLayer } from "./layer";
import { createFirebaseTransport } from "./transport";

export { createDataLayer, createFirebaseTransport };
export type { DataLayer, DataLayerOptions } from "./layer";
export type { PassResult } from "./syncer";
export {
  ANSWER_WRITE_BUDGET_MS,
  LOGOUT_SYNC_TIMEOUT_MS,
  OUTBOX_BATCH,
  SYNC_BACKOFF_MS,
  SYNC_MAX_DELAY_MS,
  nextDelay,
} from "./policy";
export type { HubEntry, HubState, Transport } from "./types";

let shared: DataLayer | null = null;

/** The app's one data layer, on the device's IndexedDB and the real server. */
export function dataLayer(): DataLayer {
  shared ??= createDataLayer({ transport: createFirebaseTransport() });
  return shared;
}
